import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (<div data-testid="page-not-found">404 Page Not Found</div>);
  }
}

export default NotFound;
